import React from "react";
import { opacity_variant } from "../../utils/animation/transitions";
import * as motion from "motion/react-m";

import styles from "./Loader.module.scss";
export const Loader = () => {
  return (
    <motion.div
      variants={opacity_variant}
      initial={"initial"}
      animate={"animate"}
      className={styles["loader-wrapper"]}
    >
      <div className={styles["box-loader"]}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </motion.div>
  );
};
